import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActionButton } from '../../../model/ui/action-button';
import { AssetFilters } from '../../../model/filters/asset-filters';
import { FilterMatchMode, FilterMetadata, FilterOperator } from 'primeng/api';
import { AssetMeasurement } from '../../../model/asset-measurement';
import { EntityWithUuid } from '../../../model/custom/entity-with-uuid';
import { Tenant } from '../../../model/tenant';
import { Organization } from '../../../model/organization';

@Component({
  selector: 'app-asset-measurements-selector',
  templateUrl: './asset-measurements-selector.component.html',
  styleUrls: ['./asset-measurements-selector.component.scss']
})
export class AssetMeasurementsSelectorComponent implements OnInit {

  private readonly DEFAULT_ASSETS_SORT_FIELD = 'alias';
  private readonly DEFAULT_ASSETS_SORT_ORDER = 1;

  @Input() tenant: Tenant;
  @Input() organization: Organization;
  @Input() selectionMode: 'single' | 'multiple' = 'single';
  @Output() selectionChange: EventEmitter<AssetMeasurement | AssetMeasurement[]>;
  @Output() visibleChange: EventEmitter<boolean>;

  public dialogVisible: boolean;
  public currentStep: number;

  public assetSelection: EntityWithUuid | EntityWithUuid[];
  public assetMeasurementSelection: AssetMeasurement | AssetMeasurement[];

  public assetFilters: AssetFilters;
  public assetMeasurementFilters: {[field: string]: FilterMetadata};

  public initialSelection: AssetMeasurement | AssetMeasurement[];

  constructor() {
    this.selectionChange = new EventEmitter<AssetMeasurement | AssetMeasurement[]>();
    this.visibleChange = new EventEmitter<boolean>();
    this.currentStep = 0;
    this.assetFilters = new AssetFilters();
    this.assetFilters.sortField = this.DEFAULT_ASSETS_SORT_FIELD;
    this.assetFilters.sortOrder = this.DEFAULT_ASSETS_SORT_ORDER;
    this.assetMeasurementFilters = {};
    this.assetMeasurementFilters.name = { value: '', matchMode: FilterMatchMode.CONTAINS, operator: FilterOperator.AND };
    this.assetMeasurementFilters['measurementType.unit'] = { value: '', matchMode: FilterMatchMode.CONTAINS, operator: FilterOperator.AND };
  }

  ngOnInit(): void {}

  @Input()
  set visible(visible: boolean) {
    this.dialogVisible = visible;
    if (!visible) {
      this.currentStep = 0;
    }
  }

  @Input()
  set selection(selection: AssetMeasurement | AssetMeasurement[]) {
    this.initialSelection = selection;

    if (this.selectionMode === 'multiple') {
      const arraySelection = selection as AssetMeasurement[];
      this.assetSelection = arraySelection.map(measurement => measurement.asset);
      this.assetMeasurementSelection = [...arraySelection];

    } else if (this.selectionMode === 'single') {
      const objectSelection = selection as AssetMeasurement;
      if (objectSelection) {
        this.assetSelection = objectSelection.asset;
        this.assetMeasurementSelection = objectSelection;
      }
    }
  }

  public updateAssetMeasurementSelection(assetSelection: EntityWithUuid | EntityWithUuid[]): void {
    if (this.selectionMode === 'multiple') {
      const arrayAssetSelection = assetSelection as EntityWithUuid[];
      const arrayAssetMeasurementSelection = this.assetMeasurementSelection as AssetMeasurement[];
      const uuids = arrayAssetSelection.map(value => value.uuid);
      this.assetMeasurementSelection = arrayAssetMeasurementSelection
        .filter(measurement => uuids.includes(measurement.asset.uuid));

    } else if (this.selectionMode === 'single') {
      this.assetMeasurementSelection = undefined;
    }
  }

  public saveAndClose(): void {
    this.selectionChange.emit(this.assetMeasurementSelection);
    this.visible = false;
    this.visibleChange.emit(false);
  }

  public closeWithoutSaving(): void {
    this.selection = this.initialSelection;
    this.visible = false;
    this.visibleChange.emit(false);
  }

  public clearSelection(): void {
    this.assetSelection = undefined;
    this.assetMeasurementSelection = undefined;
  }

}
